//HOME
export const CHANGE_SHOW_STATUS = 'changeShowStatus'
export const CHANGE_ARTICLE_LIST = 'changeArticleList'

export const CHANGE_TOPIC_SHOW = 'changeTopicShow'
export const DISPLAY_ARTICLE = 'displayArticle'
export const CHANGELOGIN = 'changeLogin'
export const CHANGELOGINWAY = 'changeLoginWay'


// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js